module.exports = __webpack_public_path__ + "img/agro_catraca_1000ml.d579f2b9.png";